import React, { useContext, useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../Context/DataContext'
import { UIContext } from '../../Context/UIContext'

import './Footer.scss'

import HomeLink from '../HomeLink'
import Social from '../Social'

const Footer = () => {
    const { sitename, tagline, rif, strings } = useContext(DataContext)
    const { showIntroLogo, currentPage } = useContext(UIContext)
    const [isVisible, setIsVisible] = useState(false)
    const [isLight, setIsLight] = useState(false)

    const copyright = `Copyright ${new Date().getFullYear()} ${sitename} ${tagline} - ${(strings && strings.copyright) || ""} RIF: ${rif}`

    useEffect(() => {
        setIsVisible(showIntroLogo === false);
    }, [showIntroLogo])

    useEffect(() => {
        if (currentPage && currentPage === 'team-partners') {
            setIsLight(true)
        } else {
            setIsLight(false)
        }
    }, [currentPage])

    return (
        <AnimatePresence mode="wait">
            {isVisible && (
                <motion.footer
                    key="mga-footer"
                    className={`mga-footer${isLight ? ' mga-footer--light' : ''}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, ease: 'easeInOut' }}
                    exit={{ opacity: 0 }}
                >
                    <HomeLink whitemode={isLight} />
                    <p dangerouslySetInnerHTML={{ __html: copyright }} />
                    <Social  whitemode={isLight} />
                </motion.footer>
            )}
        </AnimatePresence>
    )
}

export default React.memo(Footer)